import React, { useContext, useEffect } from "react";

import { ZeosApiContext } from "../../context/ZeosApiContext";
import { UploadImageForm } from "../../forms/UploadImageForm";
import { useFormValidation } from "../../hooks/useFormValidation";
import {
  defaultFileUploadForm,
  FileUploadDataType,
} from "../../services/forms/DefaultFormData";
import { fileUploadValidationSchema } from "../../services/forms/validationSchemas/fileUploadValidationSchema";
import { uploadPropertyImages } from "../../services/helpers/PropertyHelpers";
import { zeosDialog } from "../Shared/confirm-dialog/ConfirmDialog";

interface IProps {
  companyId: number;
  onCancel: () => void;
  onSuccess?: () => Promise<void> | void;
  propertyId: number;
  propertyName?: string;
}

export const PropertyImageUpload = (props: IProps) => {
  const { companyId, onCancel, onSuccess, propertyId, propertyName } = props;
  const api = useContext(ZeosApiContext);

  const { formData, setFormData, errors, formValidate, formChange } =
    useFormValidation<FileUploadDataType>(fileUploadValidationSchema, {
      ...defaultFileUploadForm,
      name: propertyName ?? "",
    });

  useEffect(() => {
    setFormData({
      ...defaultFileUploadForm,
      name: propertyName ?? "",
    });
  }, [propertyName, setFormData]);

  const handleSubmit = () => {
    formValidate(async () => {
      if (!propertyId) {
        zeosDialog("No property selected");
        return;
      }
      if (!formData.file || formData.file.length === 0) {
        zeosDialog("Please select a file");
        return;
      }

      try {
        await uploadPropertyImages(api, propertyId, formData.file);
        zeosDialog("File Uploaded Successfully");
        setFormData(defaultFileUploadForm);

        if (onSuccess) {
          await onSuccess();
        }
      } catch (error) {
        console.error("Property image upload failed", error);
        zeosDialog("Upload failed");
      }
    });
  };

  return (
    <UploadImageForm
      formData={formData}
      errors={errors}
      handleChange={formChange}
      setFormData={setFormData}
      disabled={companyId === 0}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};
